import { useMutation } from 'react-query';
import { queryCreate } from './fetch';

export const useSendNotAvailableNotification = (sessionId: string) => {
  return useMutation<void, any, { participationId: string; message: string }>(
    queryCreate(`/public-sessions/${sessionId}/not-available-notification`),
  );
};

export const useSendAction = (actionName: string) => {
  return useMutation<void, any, any>(queryCreate(`/v2/actions/${actionName}`));
};
